import React from 'react';

import { PremiumFeatureGuard } from '@qality/common-components/src/atoms/PremiumFeatureGuard';

import { TestCaseRepositoryAllTestCases } from '../TestCaseRepositoryAllTestCases';
import { TestCaseRepositoryFoldersBenefits } from '../TestCaseRepositoryFoldersBenefits/TestCaseRepositoryFoldersBenefits';
import { TestCaseRepositoryFoldersTree } from '../TestCaseRepositoryFoldersTree';
import {
  ContainerStyled,
  DividerStyled,
  WrapperStyled,
} from './TestCaseRepositorySidebarBody.styled';

export function TestCaseRepositorySidebarBody(): JSX.Element {
  return (
    <ContainerStyled>
      <TestCaseRepositoryAllTestCases />
      <DividerStyled />
      <PremiumFeatureGuard
        premium={<TestCaseRepositoryFoldersTree />}
        free={
          <WrapperStyled>
            <TestCaseRepositoryFoldersBenefits />
          </WrapperStyled>
        }
      />
    </ContainerStyled>
  );
}
